import { Typography } from 'antd';

import PageWrapper from '../MainPageWrapper/PageWrapper';
import { privacyContent } from './Privacy.const';
import css from '../About/About.module.css';

const Privacy = () => {
  const { Title } = Typography;

  return (
    <PageWrapper>
      <Title level={2} style={{ color: '#1677ff' }}>
        Политика обработки персональных данных интернет-ресурса bilet.rabt.by
      </Title>
      <div className={css.Text} dangerouslySetInnerHTML={{ __html: privacyContent }} />
    </PageWrapper>
  );
};

export default Privacy;
